import { styled } from "@theme/stitches.config"

export const FaqWrapper = styled("div", {
    display: "flex",
    flexDirection: "column",
    width: "100%"
})

export const Content = styled("div", {
    display: "flex",
    flex: "1 0 50%",
    flexDirection: "column",
    pr: 130,
    mb: 85
})

export const AccordionWrapper = styled("div", {
    display: "flex",
    flex: "1 0 50%",
    flexDirection: "column",
    maxWidth: 680
})
